import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { MuseumCreationRequest, MuseumData, MuseumEditRequest, MuseumSearchFilter } from "../../../models/museum.model";

export const museumCreationRequest = createAction(
        '[Museum] Museum creation request', props<{ museumCreationRequest: MuseumCreationRequest }>());

export const museumCreationSuccess = createAction(
        '[Museum] Museum creation success', props<{ createdMuseum: MuseumData }>());

export const museumCreationFail = createAction(
        '[Museum] Museum creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const museumEdit = createAction(
        '[Museum] Museum edit', props<{ museumToEdit: MuseumData }>());

export const museumCopy = createAction(
        '[Museum] Museum copy', props<{ museumToCopy: MuseumData }>());

export const museumEditSave = createAction(
        '[Museum] Museum edit save', props<{ museumToEdit: MuseumEditRequest }>());

export const museumEditSaveSuccess = createAction(
        '[Museum] Museum edit save success', props<{ editedMuseum: MuseumData }>());

export const museumEditSaveFail = createAction(
        '[Museum] Museum edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const museumView = createAction(
        '[Museum] Museum view', props<{ museumToView: MuseumData }>());

export const museumSearchRequest = createAction(
        '[Museum] Museum search request', props<{ searchFilter: MuseumSearchFilter }>());

export const museumSearchAllRequest = createAction(
        '[Museum] Museum search all request');

export const museumSearchSuccess = createAction(
        '[Museum] Museum search success', props<{ searchResult: MuseumData[] }>());

export const museumSearchDataReset = createAction(
        '[Museum] Museum search data reset');

export const museumSearchFail = createAction(
        '[Museum] Museum search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const museumDeleteRequest = createAction(
        '[Museum] Museum delete request', props<{ museumId: number }>());

export const museumDeleteSuccess = createAction(
        '[Museum] Museum delete success', props<{ museumId: number }>());

export const museumDeleteFail = createAction(
        '[Museum] Museum delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());